import { Helmet } from "react-helmet-async";

const SITE_URL = "https://itsallaboutgrowth.com";

interface SEOProps {
  title: string;
  description: string;
  path: string;
  ogType?: "website" | "article";
  ogImage?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export function SEO({
  title,
  description,
  path,
  ogType = "website",
  ogImage,
  jsonLd,
}: SEOProps) {
  const url = `${SITE_URL}${path}`;
  const image =
    ogImage ||
    "https://storage.googleapis.com/gpt-engineer-file-uploads/Gjq8CRsocEfAr1l5FiFQLhbZGA92/social-images/social-1771894508006-ChatGPT_Image_Feb_23_2026_Branding.webp";

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={ogType} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
